import { render, staticRenderFns } from "./sec-logistics.vue?vue&type=template&id=d1a7efbe&"
import script from "./sec-logistics.vue?vue&type=script&lang=js&"
export * from "./sec-logistics.vue?vue&type=script&lang=js&"
import style0 from "./sec-logistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sec-logistics.vue"
export default component.exports